import { Phone, MessageCircle, FileText } from "lucide-react";
import { CONTACT, waLink } from "@/lib/api";

export function StickyCTA() {
  const goQuote = () => document.querySelector("#packages")?.scrollIntoView({ behavior: "smooth" });
  return (
    <div
      data-testid="sticky-cta"
      className="fixed inset-x-0 bottom-safe z-50 md:hidden px-3 pb-3 pt-2 bg-gradient-to-t from-background via-background to-transparent"
    >
      <div className="grid grid-cols-3 gap-2">
        <a
          data-testid="sticky-whatsapp"
          href={waLink("Hi The Quisine! I'd like more info.")}
          target="_blank"
          rel="noreferrer"
          className="h-13 py-3.5 rounded-full bg-[#25D366] text-white grid place-items-center gap-1 active:scale-95 transition-transform"
        >
          <span className="flex items-center gap-1.5 text-sm font-medium"><MessageCircle className="w-4 h-4" /> WhatsApp</span>
        </a>
        <a
          data-testid="sticky-call"
          href={`tel:${CONTACT.phone}`}
          className="h-13 py-3.5 rounded-full bg-primary text-primary-foreground grid place-items-center active:scale-95 transition-transform"
        >
          <span className="flex items-center gap-1.5 text-sm font-medium"><Phone className="w-4 h-4" /> Call</span>
        </a>
        <button
          data-testid="sticky-quote"
          onClick={goQuote}
          className="h-13 py-3.5 rounded-full border border-primary text-primary bg-background grid place-items-center active:scale-95 transition-transform"
        >
          <span className="flex items-center gap-1.5 text-sm font-medium"><FileText className="w-4 h-4" /> Quote</span>
        </button>
      </div>
    </div>
  );
}
